export const resources=[
  {
    id: 8,
    title: "40+ Free Business Calculators",
    type: "40+ free calculators",
    description: "Explore more than 40 free online calculators in one central library. Choose the calculator you need and open it directly from the BPA Solutions website.",
    highlights: [
      "Access a collection of 40+ free online calculators",
      "Browse the calculator library in one place",
      "Free to access with no paid licence required"
    ],
    publishedAt: "2026-11-05",
    downloadUrl: "https://calculators.bpasolutions.au/",
    imageUrl: "https://cloud.sharemyimage.com/2026/11/05/Calculators-2.png",
    imageAlt: "BPA Solutions collection of more than 40 free online calculators",
    previewImages: [
      "https://cloud.sharemyimage.com/2026/11/05/Calculators-2.png",
      "https://cloud.sharemyimage.com/2026/11/05/Calculators-3.png",
      "https://cloud.sharemyimage.com/2026/11/05/Calculators-1.png"
    ],
    directAccess: true,
    ctaLabel: "Open free calculators",
    tags: ["40+ Calculators", "Free Tools", "Business Calculators"]
  },

  {
    id: 1,
    title: "InboxSignal Email List Cleaning and Validation Tool",
    type: "free tool",
    description: "Test and explore BPA Solutions' InboxSignal tool to help identify risky,low-quality,or invalid email addresses before they affect your outreach and campaign performance. A practical free resource for businesses wanting cleaner email lists and better sender confidence.",
    highlights: [
      "Identify risky or invalid email addresses",
      "Improve list quality before outreach",
      "Protect sender confidence and campaign performance"
    ],
    publishedAt: "2024-05-22",
    downloadUrl: "https://app.bpasolutions.au/Inbox-Signal-Email-Checker",
    imageUrl: "https://cdn1.sharemyimage.com/smi/2026/04/13/Free-Email-Checker.png",
    imageAlt: "InboxSignal email list cleaning and validation tool by BPA Solutions",
    ctaLabel: "Open free tool"
  },
  {
    id: 2,
    title: "BPA Smart Lead Management System Demo",
    type: "free demo",
    description: "Explore the BPA Solutions Smart Lead Management System demo and see how structured digital enquiry capture,smart routing,and cleaner lead handling can improve response quality and reduce missed opportunities.",
    highlights: [
      "Capture enquiries in a structured way",
      "Improve routing and response quality",
      "Reduce missed opportunities from manual handling"
    ],
    publishedAt: "2024-05-22",
    downloadUrl: "https://app.bpasolutions.au/Smart-forms",
    imageUrl: "https://cdn1.sharemyimage.com/smi/2026/04/13/BPA-Smart-Forms.png",
    imageAlt: "BPA Smart Lead Management System demo by BPA Solutions",
    ctaLabel: "View demo"
  },
  {
    id: 3,
    title: "Snippet Boss Free Resource",
    type: "free tool",
    description: "Explore Snippet Boss,a free BPA Solutions resource designed to help business owners,consultants,and teams manage reusable text,proposal snippets,scripts,templates,and quick-copy content in one organised workspace.",
    highlights: [
      "Store reusable snippets,scripts,and templates",
      "Speed up proposals,follow-ups,and repeated messages",
      "Keep frequently used business content organised and ready to copy"
    ],
    publishedAt: "2024-05-22",
    downloadUrl: "https://app.bpasolutions.au/Snippet-Boss-Front-Free_Resource",
    imageUrl: "https://cdn1.sharemyimage.com/smi/2026/04/27/ChatGPT-Image-Apr-27-2026-04_23_30-PM.png",
    imageAlt: "Snippet Boss free resource by BPA Solutions for managing reusable business snippets and templates",
    ctaLabel: "Open Snippet Boss"
  },
  {
    id: 4,
    title: "SafePDF Browser-Based PDF Toolkit",
    type: "free tool",
    description: "SafePDF is a free browser-based PDF toolkit that allows businesses and individuals to manage and edit PDF files quickly without uploading documents to external servers. It is designed for simple,everyday PDF tasks while maintaining stronger privacy control.",
    highlights: [
      "Merge,split,rotate and organise PDF files easily",
      "Add page numbers,sign and redact documents",
      "Runs entirely in your browser so files stay on your device"
    ],
    publishedAt: "2024-05-22",
    downloadUrl: "https://app.bpasolutions.au/PDF-Tools-Free-Resource",
    imageUrl: "https://cdn1.sharemyimage.com/smi/2026/04/27/Safe-PDF-1.png",
    imageAlt: "SafePDF browser based PDF toolkit for secure document editing",
    ctaLabel: "Open PDF tool"
  },
  {
    id: 5,
    title: "DataMerge Pro Excel and CSV Consolidation Tool",
    type: "complimentary resource",
    description: "Combine multiple Excel and CSV files into one clean master dataset. Smart column mapping helps align different headers,preview the result,andexport a structured file. Everything runs locally in your browser,so your spreadsheet data stays on your device.",
    highlights: [
      "Merge CSV,XLS and XLSX files into one output",
      "Smart column mapping for different headers",
      "Preview consolidated data before export",
      "Local browser processing - no file upload"
    ],
    publishedAt: "2026-04-29",
    downloadUrl: "https://app.bpasolutions.au/Consolidate-Excel-Files",
    imageUrl: "https://cdn1.sharemyimage.com/smi/2026/04/29/Merge-Excel-Files-2.png",
    imageAlt: "DataMerge Pro Excel and CSV consolidation tool by BPA Solutions",
    ctaLabel: "Send access link",
    tags: ["Excel","Data Cleaning","Privacy First","Browser Based"]
  },
  {
    id: 6,
    title: "SplitFlow Studio",
    type: "complimentary resource",
    description: "Split one large spreadsheet into multiple clean files in seconds. Choose a column like Client,Project,or Category,andexport neatly organised outputs without manual work. Everything runs locally in your browser for complete privacy.",
    highlights: [
      "Split Excel and CSV files instantly",
      "Choose Client,Project,or Category",
      "Cleanexport files ready to use",
      "Local browser processing only",
      "No uploads"
    ],
    publishedAt: "2026-04-29",
    downloadUrl: "https://app.bpasolutions.au/Split-Flow-App",
    imageUrl: "https://cdn1.sharemyimage.com/smi/2026/04/29/SplitFlow2.png",
    imageAlt: "SplitFlow Studio Excel and CSV file splitter by BPA Solutions",
    ctaLabel: "Send access link",
    tags: ["Excel","CSV","Data Processing","Privacy First","Browser Based"]
  },
  {
    id: 7,
    title: "VectorCraft Studio - Image Vectorizer, Favicon Creator & QR Generator",
    type: "complimentary resource",
    description: "VectorCraft Studio is a private browser-based image and QR design toolkit that helps users convert raster images into scalable vector graphics, create website favicons, and generate branded QR codes. Convert PNG and JPG images into SVG vector files, export professional design formats, create website icons, and customise QR codes with logos and colours while keeping files private through local browser processing.",
    highlights: [
      "Convert PNG, JPG and JPEG images into scalable SVG vectors",
      "Export professional design formats including SVG, EPS, PDF and PNG",
      "Create website favicons and icon files",
      "Generate branded QR codes with logos and custom colours",
      "Private browser-based processing with no uploads or external APIs"
    ],
    publishedAt: "2026-07-23",
    downloadUrl: "https://vcs.bpasolutions.au/",
    imageUrl: "https://cloud.sharemyimage.com/2026/07/23/vcs-1.png",
    imageAlt: "VectorCraft Studio image vectorizer, favicon creator and branded QR code generator by BPA Solutions",
    ctaLabel: "Send access link",
    tags: [
      "Image Vectorizer",
      "PNG to SVG",
      "JPG to SVG",
      "SVG Converter",
      "Vector Graphics",
      "Logo Design",
      "Favicon Generator",
      "ICO Creator",
      "QR Code Generator",
      "Branded QR Codes",
      "SVG Export",
      "EPS Export",
      "PDF Export",
      "Browser Based",
      "Privacy First",
      "No Upload",
      "Design Tools"
    ]
  }
];